import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getPaymentMessage = (state: StateScheme) => {
    return state.payment.message
}
